import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const statusLabels = {
  pending_payment: { label: 'Payment pending', color: '#f59e0b' },
  paid: { label: 'Processing', color: '#3b82f6' },
  sent: { label: 'Waiting for tenant', color: '#8b5cf6' },
  tenant_submitted: { label: 'Processing', color: '#3b82f6' },
  processing: { label: 'Generating report', color: '#3b82f6' },
  report_ready: { label: 'Report ready', color: '#10b981' },
  viewed: { label: 'Viewed', color: '#6b7280' },
};

function ScreeningList() {
  const [screenings, setScreenings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const justPaid = searchParams.get('paid');

  useEffect(() => {
    const fetchScreenings = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/screening/list`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setScreenings(data.screenings || []);
        }
      } catch (err) {
        console.error('Failed to load screenings:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchScreenings();
  }, []);

  if (loading) {
    return <main className="App-main"><p style={{ textAlign: 'center', marginTop: '3rem' }}>Loading...</p></main>;
  }

  return (
    <main className="App-main">
      <div style={{ maxWidth: 680, margin: '2rem auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '0.75rem' }}>
          <div>
            <h2 style={{ margin: 0 }}>Your screenings</h2>
            <p className="status-text" style={{ marginTop: '0.25rem' }}>Track all your tenant screening requests.</p>
          </div>
          <Link to="/screen" className="primary-button" style={{ textDecoration: 'none', fontSize: '0.9rem' }}>Screen a tenant</Link>
        </div>

        {justPaid && (
          <div style={{
            padding: '1rem 1.25rem', borderRadius: '10px', marginBottom: '1.25rem',
            background: 'rgba(16, 185, 129, 0.08)', border: '1px solid rgba(16, 185, 129, 0.2)'
          }}>
            <p style={{ margin: 0, fontSize: '0.9rem' }}>
              ✅ Payment confirmed! Your tenant will receive an email shortly to complete the screening.
            </p>
          </div>
        )}

        {screenings.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>📋</div>
            <p className="status-text">No screenings yet.</p>
            <Link to="/screen" className="secondary-button" style={{ marginTop: '1rem', textDecoration: 'none', display: 'inline-block' }}>Screen your first tenant</Link>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {screenings.map(s => {
              const st = statusLabels[s.status] || { label: s.status, color: '#6b7280' };
              const isReady = s.status === 'report_ready' || s.status === 'viewed';
              return (
                <div key={s.id} style={{
                  padding: '1rem 1.25rem', borderRadius: '12px',
                  border: '1px solid var(--border-color, #e5e7eb)',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  gap: '1rem', flexWrap: 'wrap'
                }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>{s.tenant_name || s.tenant_email}</div>
                    <div className="status-text" style={{ fontSize: '0.82rem' }}>
                      {s.rental_address}{s.rental_unit ? `, Unit ${s.rental_unit}` : ''}
                    </div>
                    <div style={{ marginTop: '0.35rem' }}>
                      <span style={{
                        fontSize: '0.72rem', fontWeight: 600, color: st.color,
                        background: `${st.color}15`, padding: '0.2rem 0.5rem', borderRadius: '999px'
                      }}>{st.label}</span>
                    </div>
                  </div>
                  <div>
                    {isReady ? (
                      <Link to={`/landlord/screenings/${s.id}`} className="secondary-button" style={{ fontSize: '0.82rem', textDecoration: 'none', padding: '0.4rem 0.75rem' }}>
                        View report
                      </Link>
                    ) : (
                      <span className="status-text" style={{ fontSize: '0.78rem' }}>
                        {new Date(s.created_at).toLocaleDateString()}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </main>
  );
}

export default ScreeningList;
